// A post's preview_token (see Post#preview_token / PostsController#set_post!)
// grants access to a not-yet-announced post via a shared link. It's carried
// entirely in the page URL — reading it here instead of threading it as a
// prop through every component means any request scoped to "the post this
// page is about" (songs, related posts, etc.) picks it up automatically,
// with no risk of missing a spot as new post-detail requests get added.
//
// It's safe to attach to unrelated requests: the backend checks it against
// that specific post's own derived token, so it's simply ignored/rejected
// wherever it doesn't apply.
export function getPreviewTokenFromUrl() {
  if (typeof window === "undefined") return undefined
  return (
    new URLSearchParams(window.location.search).get("preview_token") ||
    undefined
  )
}
